import React from 'react';
import styled from 'styled-components';
import { useNavigate } from 'react-router-dom';
import SubHeader from './SubHeader';
import { Button, HEADER_BACKGROUND_COLOR, HEADER_TEXT_COLOR } from '../GlobalStyles';
import { useAuth } from './Authorization/AuthContext';

const Header: React.FC = () => {
  const navigate = useNavigate();
  const { user, msalAccount, isAuthenticated, signoutRedirect, selectedProject, clearSelectedProject, authorization } = useAuth();

  const handleTitleClick = () => {
    navigate('/home');
  };

  const handleChangeProject = () => {
    clearSelectedProject();
  };

  // Resolve display name from whichever auth provider is active
  const displayName = user
    ? (user.profile?.name || user.profile?.email || '')
    : (msalAccount?.name || msalAccount?.username || '');

  return (
    <HeaderContainer>
      <HeaderRow>
        {/* Left */}
        <HeaderTitle onClick={handleTitleClick}>NEPA Public Comment Agency Review (PCAR)</HeaderTitle>

        {/* Center */}
        {isAuthenticated && selectedProject && (
          <ProjectInfo>
            <ProjectDetails>
              <ProjectName>{selectedProject.projectName}</ProjectName>
              {selectedProject.readonly && (
                <ReadOnlyIndicator>READ ONLY</ReadOnlyIndicator>
              )}
            </ProjectDetails>
            {authorization?.projects && authorization.projects.filter(p => p.enablePcar === true).length > 1 && (
              <Button variant="secondary" onClick={handleChangeProject}>
                Change Project (DB)
              </Button>
            )}
          </ProjectInfo>
        )}

        {/* Right */}
        {isAuthenticated && (
          <UserSection>
            <UserName>{displayName}{selectedProject?.role ? ` (${selectedProject.role})` : ''}</UserName>
            <Button variant='secondary' onClick={signoutRedirect}>Logout</Button>
          </UserSection>
        )}
      </HeaderRow>
      <SubHeader />
    </HeaderContainer>
  );
};

const HeaderContainer = styled.div`
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  z-index: 1000;
  background: ${HEADER_BACKGROUND_COLOR};
`;

export const HeaderRow = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  width: 100%;
  padding: 0 24px;
  min-height: 60px;
  box-sizing: border-box;
`;

const HeaderTitle = styled.span`
  color: ${HEADER_TEXT_COLOR};
  font-size: 25px;
  font-weight: bold;
  cursor: pointer;
  flex: 0 0 auto;
  display: flex;
  align-items: center;
`;

export const ProjectInfo = styled.div`
  flex: 1;
  display: flex;
  justify-content: center;
  align-items: center;
`;

const ProjectDetails = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  margin-right: 12px;
`;

const ProjectName = styled.h2`
  font-weight: normal;
  color: ${HEADER_TEXT_COLOR};
  margin: 0;
`;

const ReadOnlyIndicator = styled.span`
  font-weight: bold;
  color: #dc3545;
  font-size: 12px;
  letter-spacing: 1px;
`;

const UserSection = styled.div`
  flex: 0 0 auto;
  display: flex;
  align-items: center;
  gap: 15px;
`;

const UserName = styled.span`
  color: ${HEADER_TEXT_COLOR};
  font-size: 14px;
`;

export default Header;